import Appointment from "./Appointment/Route";
import Branch from "./Branch/Route";

export default [...Appointment, ...Branch];
